'use strict'

import Config from '../app.config.js'
import request from 'axios'
import localforage from 'localforage'
import store from 'src/vuex/store'

request.defaults.baseURL = Config.apiDomain

let requestConfig = {}

const httpService = {
  init: () => {
    const token = store.getters['tokens/accessToken']
    if (token) {
      requestConfig.headers = {
        Authorization: 'Bearer ' + token,
      }
    }
  },
  store: '',
  storeCacheTime: '',
  currentTime: '',
  isBrowser: false,
  networkFirstStrategy: (path, cacheTime) => {
    return new Promise((resolve, reject) => {
      request
        .get(path, requestConfig)
        .then(response => {
          // Response returned, cache it and return it
          if (response.status === 200) {
            if (httpService.isBrowser) {
              httpService.storeCacheTime.setItem(
                path,
                httpService.currentTime + cacheTime
              )
              httpService.store
                .setItem(path, {
                  data: response.data,
                  headers: response.headers,
                })
                .then(response => resolve(response))
                .catch(err => reject(err))
            } else {
              resolve(response)
            }
          } else {
            if (httpService.isBrowser) {
              httpService.store
                .getItem(path)
                .then(response => resolve(response))
                .catch(err => reject(err))
            } else {
              reject(new Error('Cannot get ' + path))
            }
          }
        })
        .catch(error => {
          console.log(error)
        })
    })
  },
  offlineFirstStrategy: (path, cacheTime) => {
    return new Promise((resolve, reject) => {
      httpService.storeCacheTime
        .getItem(path)
        .then(function(timeLastCached) {
          // Cache has expired
          if (timeLastCached < httpService.currentTime) {
            httpService
              .networkFirstStrategy(path, cacheTime)
              .then(response => {
                resolve(response)
              })
              .catch(err => reject(err))
          } else {
            // Get item from cache
            httpService.store
              .getItem(path)
              .then(response => {
                if (response) {
                  // Is in cache perfect!
                  resolve(response)
                } else {
                  // Doesn't exist in cache try network
                  httpService
                    .networkFirstStrategy(path, cacheTime)
                    .then(response => resolve(response))
                    .catch(err => reject(err))
                }
              })
              .catch(error => {
                console.log(error)
                // Doesn't exist in cache try network
                httpService
                  .networkFirstStrategy(path, cacheTime)
                  .then(response => resolve(response))
                  .catch(err => reject(err))
              })
          }
        })
        .catch(error => {
          console.log(error)
          // Doesn't exist in cache timeouts try network
          httpService
            .networkFirstStrategy(path, cacheTime)
            .then(response => resolve(response))
            .catch(err => reject(err))
        })
    })
  },
  get: function(path, cacheTime) {
    return new Promise((resolve, reject) => {
      httpService.currentTime = Math.floor(Date.now() / 1000)
      httpService.isBrowser = typeof window !== 'undefined'
      if (httpService.isBrowser) {
        httpService.store = localforage.createInstance({
          name: Config.loadDbName,
        })
        httpService.storeCacheTime = localforage.createInstance({
          name: Config.loadDbName + '_cacheTime',
        })
      }
      if (!cacheTime || cacheTime === 0 || !httpService.storeCacheTime) {
        httpService
          .networkFirstStrategy(path, 0)
          .then(response => {
            if (!response) {
              resolve('')
            } else {
              resolve(response)
            }
          })
          .catch(err => {
            reject(err)
          })
      } else {
        httpService
          .offlineFirstStrategy(path, cacheTime)
          .then(response => {
            if (!response) {
              resolve('')
            } else {
              resolve(response)
            }
          })
          .catch(err => reject(err))
      }
    })
  },
  post: function(path, data) {
    return request.post(path, data, requestConfig)
  },
  delete: function(path) {
    return request.delete(path, requestConfig)
  },
  patch: function(path, data) {
    return request.patch(path, data, requestConfig)
  },
  put: function(path, data) {
    return request.put(path, data, requestConfig)
  },
  getLocal: function(path) {
    return new Promise((resolve, reject) => {
      httpService.currentTime = Math.floor(Date.now() / 1000)
      httpService.isBrowser = typeof window !== 'undefined'
      if (httpService.isBrowser) {
        httpService.store = localforage.createInstance({
          name: Config.loadDbName,
        })
        httpService.storeCacheTime = localforage.createInstance({
          name: Config.loadDbName + '_cacheTime',
        })
      }
      if (httpService.isBrowser) {
        httpService.store
          .getItem(path)
          .then(response => resolve(response))
          .catch(err => reject(err))
      } else {
        reject(new Error('Cannot get ' + path))
      }
    })
  },
  setLocal: function(path, cacheTime, data) {
    return new Promise((resolve, reject) => {
      httpService.currentTime = Math.floor(Date.now() / 1000)
      httpService.isBrowser = typeof window !== 'undefined'
      if (httpService.isBrowser) {
        httpService.store = localforage.createInstance({
          name: Config.loadDbName,
        })
        httpService.storeCacheTime = localforage.createInstance({
          name: Config.loadDbName + '_cacheTime',
        })
      }
      httpService.storeCacheTime.setItem(
        path,
        httpService.currentTime + cacheTime
      )
      httpService.store
        .setItem(path, data)
        .then(response => resolve(response))
        .catch(err => reject(err))
    })
  },
}

export default httpService
